/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_BlogInputs */

const es_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const gl_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const en_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

/**
* | output |
* | --- |
* | "Blog" |
*
* @param {Footer_Link_BlogInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_link_blog = /** @type {((inputs?: Footer_Link_BlogInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_BlogInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_link_blog(inputs)
	if (locale === "en") return en_footer_link_blog(inputs)
	return es_footer_link_blog(inputs)
});